export default {
  conversation_dnd_message: '{name} is on DND',
  conversation_dnd_message_with_time:
    '{name} is on DND until {time, time, short}',
  conversation_dnd_message_tooltip_content:
    "{name} won't receive notifications",
};
